import { render, staticRenderFns } from "./RekapPerMapelUjian.vue?vue&type=template&id=175bcb44"
import script from "./RekapPerMapelUjian.vue?vue&type=script&lang=js"
export * from "./RekapPerMapelUjian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports